<template>
  <v-container
    :style="$vuetify.theme.dark ? '' : 'background: #eeeeee'"
    style="min-height: 110vh"
  >
    <v-row class="mb-1">
      <v-col cols="12" md="3">
        <h2 class="mt-1">
          <span class="grey--text">{{ $t("resorce.title") }}</span>
        </h2>
      </v-col>
      <v-col offset="7" md="2" class="mt-1" style="text-align: right"> </v-col>
    </v-row>
    <v-btn
      fixed
      color="primary"
      class="white--text ma-3"
      @click="openDialog()"
      fab
      left
      v-if="$i18n.locale == 'ar' && permission.branch"
      bottom
    >
      <v-icon>mdi-plus</v-icon>
    </v-btn>
    <v-btn
      fixed
      color="primary"
      class="white--text ma-3"
      @click="openDialog()"
      fab
      right
      v-else-if="permission.branch"
      bottom
    >
      <v-icon>mdi-plus</v-icon>
    </v-btn>

    <v-row>
      <v-col cols="12" v-if="geoPlace.length > 0">
        <Table :data="geoPlace" />
      </v-col>
      <v-col v-else>
        <v-card class="text-center py-16" elevation="0">
          <h3 class="gray-text ma-3">{{ $t("resorce.empty") }}</h3>
          <P class="gray-text">{{ $t("resorce.lable") }}</P>
          <v-chip
            close-icon="mdi-plus"
            color="primary"
            @click="openDialog()"
            label
            v-if="permission.branch"
            outlined
          >
            {{ $t("resorce.create") }}
          </v-chip>
        </v-card>
      </v-col>
    </v-row>

    <Popup
      :dialog="dialog"
      :update="false"
      :data="{ R: 5 }"
      @close-dialog="close"
    />
  </v-container>
</template>

<script>
import LoadCard from "@/views/components/LoadCard.vue";
import Table from "./Table.vue";
import Popup from "./Popup.vue";
import { mapState } from "vuex";
export default {
  name: "palce-page",
  components: { Table, Popup, LoadCard },
  data() {
    return {
      dialog: false,
    };
  },
  computed: {
    ...mapState("users", ["permission"]),
    ...mapState(["geoPlace"]),
  },
  methods: {
    openDialog() {
      this.dialog = true;
    },
    close(val) {
      this.dialog = val;
      this.$store.dispatch("getGeoPlace");
    },
  },
};
</script>
